import { Text, TypographyPage } from 'ui';

export default {
  letters: {
    i: {
      text: 'Not be afraid to spend time alone and even be energized by it',
    },
    n: {
      text: 'Curious minds who think of ideas and possibilities of improving anything',
    },
    f: {
      text: 'Place a weight on feelings and values rather than thoughts when making decisions.',
    },
    p: {
      text: 'Prefer spontaneity and flexibility over planning and organization.',
    },
  },
  persons: [
    {
      slug: 'poe',
      name: 'Edgar Allen Poe',
    },
    {
      slug: 'cage',
      name: 'Nicolas Cage',
    },
    {
      slug: 'warhol',
      name: 'Andy Warhol',
    },
  ],
  advantages: [
    'Highly perceptive',
    'Thoughtful',
    'Loyal to their loved ones',
    'Supportive of others',
  ],
  disadvantages: [
    'Reserved',
    'Daydreamer',
    'Overlook small details',
    'Highly Sensitive',
  ],
  aboutUsCards: [
    {
      color: 'orange',
      title: 'Introverted',
      text: 'It can be hard to get to know INFP individuals due to their introversion. INFPs are not shy, but they gain energy from spending quality time with themselves and tend to be reserved and quiet. They are drained by social situations and prefer to interact with a small group of good friends.',
    },
    {
      color: 'red',
      title: 'Close friends',
      text: 'People with this personality type tend to develop close and personal relationships with their friends, where they thrive in giving comfort and support to others. The mediator\'s personality is extremely caring and thoughtful, and they are sensitive to the feelings of other people. INFPs dislike superficial connections and prefer deep and meaningful relationships with others.',
    },
    {
      color: 'mint',
      title: 'Big picture thinkers',
      text: 'INFP individuals often see the big picture, relying on intuition and not focusing on little details. Although they don’t tend to focus on the nitty-gritty of things, they can become extremely meticulous about projects that they are interested in. They seem not to care about boring, unimportant details.',
    },
  ],
  aboutTypeDescription:
    'The INFP personality type is described as the mediator. They are introverted, intuitive, feeling, and perceptive individuals. People with this personality type tend to be introverted, artistic, and driven by deep emotions.',
  aboutTypeTextContent: (
    <TypographyPage dense>
      <Text>
      INFPs have a strong desire to improve the world around them for the people they love. The mediator personality often makes it their mission in life to gain a greater understanding of the world and how they can help others find their calling.

      </Text>
      <Text>
      INFPs are one of the most tolerant and open-minded personality types. It is in the INFPs’ second nature to accept other people’s decisions, lifestyle choices, and belief systems. The INFP prefers to be compassionate instead of finding faults in others. Many INFPs often feel empathetic towards people who have done wrong and made great mistakes in their lives.

      </Text>
    </TypographyPage>
  ),
}